import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, UserRound, X } from "lucide-react";
import { LOGO, NAV } from "../../lib/content";
import { useAuth } from "../../context/AuthContext";

const linkCls = ({ isActive }) =>
  `relative text-sm font-medium tracking-wide transition-colors duration-200 hover:text-[#FF1F8E] ${isActive ? "text-[#FF1F8E]" : "text-white/85"}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 bg-[#0E0B0D]/95 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2 sm:px-6">
        <Link to="/" className="shrink-0 rounded-2xl bg-white px-3 py-1 transition-transform duration-200 hover:scale-[1.03]" data-testid="header-logo-link">
          <img src={LOGO} alt="KMK Customs Embroidery" className="h-11 w-auto sm:h-12" />
        </Link>
        <nav className="hidden items-center gap-7 lg:flex" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to={user ? (user.role === "admin" ? "/admin" : "/account") : "/account/login"} aria-label={user ? "My account" : "Sign in"}
            className="flex items-center gap-1.5 rounded-full p-2 text-sm font-medium text-white/85 transition-colors hover:text-[#FF1F8E]" data-testid="header-account-link">
            <UserRound className="h-5 w-5" /><span className="hidden xl:inline">{user ? (user.role === "admin" ? "Admin" : "My Orders") : "Sign in"}</span>
          </Link>
          <Link to="/order" className="btn-pink !px-4 !py-2.5 text-sm sm:!px-6" data-testid="header-order-btn"><span className="sm:hidden">Order Now</span><span className="hidden sm:inline">Start a Custom Order</span></Link>
          <button className="rounded-full p-2 text-white lg:hidden" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-toggle">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      <div className="stitch-line opacity-70" />
      {open && (
        <nav className="flex flex-col gap-1 bg-[#0E0B0D] px-6 py-4 lg:hidden" data-testid="mobile-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end onClick={() => setOpen(false)} className={(s) => `${linkCls(s)} py-3 text-base`} data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
